<template>
  <dt class="mt-4 text-sm font-semibold text-neutral-500">
    {{ title }}
  </dt>
  <dd
    class="mt-1 flex items-baseline justify-between md:block lg:flex"
    :class="{ 'animate-pulse': loading }"
  >
    <div
      class="flex flex-wrap items-baseline text-2xl font-semibold text-primary"
    >
      {{ format(currentValue) }}
      <span
        class="ml-2 text-sm font-medium text-neutral-500"
      >
        from {{ format(previousValue) }}
      </span>
    </div>
    <ComparisonChip
      variant="platform"
      class="md:mt-2 lg:mt-0"
      :direction="changeIsPositive ? 'up' : 'down'"
      :tone="changeIsPositive ? 'positive' : 'negative'"
      :value="format(change)"
      :sr-label="
        changeIsPositive ? 'Increased by' : 'Decreased by'
      "
    />
  </dd>
</template>

<script setup lang="ts">
import type { MerchantCurrencyCode } from "@/utils/currency"
import { formatNumberWithCommas } from "@/utils/formatting"

type Props = {
  title: string
  currentValue?: number
  previousValue?: number
  loading?: boolean
  type?: "number" | "currency"
  currency?: MerchantCurrencyCode
}

const props = defineProps<Props>()
const { defaultMerchantCurrency } = useOrganizationConfig()

const change = computed(() =>
  props.currentValue === undefined ||
  props.previousValue === undefined
    ? undefined
    : props.currentValue - props.previousValue
)

const changeIsPositive = computed(
  () => (change.value ?? 0) > 0
)

const format = (value: number | undefined) => {
  if (value === undefined) {
    return "----"
  }
  return props.type === "currency"
    ? formatToCurrencyString(
        value,
        props.currency ?? defaultMerchantCurrency.value
      )
    : formatNumberWithCommas(value)
}
</script>
